function ViewportHalfScrolled() {
    this.build();
}

ViewportHalfScrolled.prototype.build = function () {

    let progress = 0;

    ScrollTrigger.create({
        trigger: ".scroll-content",
        start: function () {
            return window.innerHeight / 3;
        },
        onUpdate: function(self){
            if( !self.isActive ){
                $('body').removeClass('viewport-half-scrolled');
            }else if( self.direction < 0 && ( progress - self.scroll() ) > 10 ){
                $('body').removeClass('viewport-half-scrolled');
            }else if( self.isActive && self.direction > 0 ){
                $('body').addClass('viewport-half-scrolled');
            }
            progress = self.scroll();
        }
    });
};
